import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import "../../../../src/content/national-law-enforcement-ministry/national-law-enforcement-update.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  React
};